import { render, staticRenderFns } from "./xlsxViewer.vue?vue&type=template&id=fe45cc4a&scoped=true"
import script from "./xlsxViewer.vue?vue&type=script&lang=js"
export * from "./xlsxViewer.vue?vue&type=script&lang=js"
import style0 from "./xlsxViewer.vue?vue&type=style&index=0&id=fe45cc4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe45cc4a",
  null
  
)

export default component.exports